/**
 * @module Pagination
 */
import '../../../images/sprite/arrow.svg';
import Component from '../Component';
import './styles.css';

/**
 * Пагинация.
 */
export default class Pagination extends Component {
    static className = 'pagination';

    /**
     * Обновляем шаблон компонента пагинации
     *
     * @param {any} page - Страница, которая должна быть активирована
     * @param {any} block - Блок пагинации
     * @return {any} void
     */
    updatePaginationTemplate(page, block) {
        /** Блок пагинации */
        const mainPaginationBlock = block;

        $.ajax({
            url: '/api/internal/component/base:pagination',
            method: 'post',
            data: {
                p: page,
                ajaxLoadComponent: mainPaginationBlock.attr('data-ajax-load-component'),
                perPage: mainPaginationBlock.attr('data-per-page'),
                itemsCount: mainPaginationBlock.attr('data-items-count'),
            },
            success(paginationResponse) {
                mainPaginationBlock.replaceWith(paginationResponse);
            },
        });
    }

    getQuery() {
        // eslint-disable-next-line no-restricted-globals
        const { href } = location;
        const arHref = href.split('?');

        return arHref.length > 1 ? `?${arHref[1]}` : '';
    }

    /**
     * Получаем значение GET параметра в строке
     *
     * @param {any} string - описание
     * @param {any} parameter - описание
     * @return {any} string
     */
    getParameterFromString(string, parameter) {
        // eslint-disable-next-line no-useless-escape
        const resultArray = new RegExp(`[\?&]${parameter}=([^&#]*)`).exec(string);
        let result = null;
        if (resultArray) {
            result = resultArray[1] || 0;
        }

        return result;
    }

    /**
     * Изменяем (добавляем) параметр в адресной строке
     *
     * @param {any} name - Ключ параметра
     * @param {any} value - Новое значение параметра
     * @return {any} void
     */
    changeParameterInUrl(name, value) {
        const url = window.location.href;
        const urlArray = url.split('?');
        if (urlArray.length < 2) {
            const newUri = this.isEmpty(value) ? '' : `?${name}=${value}`;
            // eslint-disable-next-line no-restricted-globals
            history.pushState('data', '', window.location.pathname + newUri);
            return;
        }

        // eslint-disable-next-line no-unused-vars
        const baseURL = urlArray[0];
        const strParams = urlArray[1].replace('?&', '?').replace('&&', '&');
        const paramsArray = strParams.split('&');
        // eslint-disable-next-line vars-on-top
        var finded = false;

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < paramsArray.length; i++) {
            const curParams = paramsArray[i].split('=');
            if (curParams[0] == name && !this.isEmpty(value)) {
                finded = true;
                paramsArray[i] = `${name}=${value}`;
            }
        }

        if (finded === false && !this.isEmpty(value)) {
            paramsArray.push(`${name}=${value}`);
        }

        const newUri = `?${paramsArray.join('&')}`;
        // eslint-disable-next-line no-restricted-globals
        history.pushState('data', '', window.location.pathname + newUri);
    }

    isEmpty(value) {
        return value === false || (typeof value == 'string' && value.trim() == '');
    }
}
